var exports = {
  "wx": "xfd349460--03affa--header",
  "Qs": "xfd349460--03affa--content",
  "kL": "xfd349460--03affa--container",
};

module.exports = exports;
